<!-- eslint-disable import/no-cycle -->
<template>
  <div>
    <section>
      <b-row class="match-height">
        <!-- range -->
        <b-col md="4">
          <b-form-group>
            <h5>Período</h5>
            <flat-pickr
              v-model="rangeDate"
              class="form-control"
              :config="{ mode: 'range'}"
              placeholder="período da busca"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <h5>Loja</h5>
            <v-select
              v-model="store"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              :options="stores"
              placeholder="Selecione"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            :disabled="show"
            variant="outline-primary"
            @click="show = true, getUTMS(store.uuid, rangeDate)"
          >
            Gerar Relatório
          </b-button>
        </b-col>
      </b-row>

      <br>
    </section>

    <section>
      <b-overlay
        :show="show"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <!--<b-row>
          <b-col
            lg="3"
            sm="6"
            v-for="status in statuses"
            :key="status"
            class="mb-2 mb-md-0"
          >
            <statistic-card-horizontal
              :icon="status.icon"
              :statistic="'R$ ' + new Intl.NumberFormat('id').format(status.amount)"
              :statistic-title="status.total"
              :color="status.color"
            />
          </b-col>
        </b-row>--->
        <!----<wordcloud
      :data="defaultWords"
      nameKey="name"
      valueKey="value"
      :color="myColors"
      :showTooltip="true"
      :wordClick="wordClickHandler">
      </wordcloud>-->
        <b-row>
          <b-col cols="6">
            <b-card
              title="UTMs"
            >

              <b-card-text />
              <app-collapse
                v-for="utm in utms"
                v-if="utms"
                :key="utm.utm_source"
                hover
              >

                <app-collapse-item
                  v-if="utm.utm_source !== null"
                  :title="utm.utm_source"
                >
                  <b-card class="border">
                    <b-card-text class="card-text">
                      <h6>Número de Pedidos: {{ utm.count }}</h6>

                      <!----<h6>Total em Pedidos: R${{ utm.amount }}</h6> --->

                      <b-table
                        v-if="utm.utm_campaigns.length > 0"
                        :fields="fields"
                        :items="utm.utm_campaigns"
                      >
                        <template #cell(amount)="amount">
                          {{ Intl.NumberFormat('id').format(amount.item.amount) }}
                        </template>
                      </b-table>

                      <!---<b-table responsive="sm" :items="utm.utm_campaigns"/>--->
                    </b-card-text>

                  </b-card>
                </app-collapse-item>
              </app-collapse>
            </b-card>
          </b-col>

          <b-col cols="6">
            <b-card
              title="Cupons"
            >
              <b-card-text>
                Atenção: Constam na ManyConvert, somente os cupons utilizados apartir do dia 17/02/2024.
              </b-card-text>
              <b-table
                v-if="coupons.length > 0"
                :fields="fields"
                :items="coupons"
              >
                <template #cell(amount)="amount">

                  {{ Intl.NumberFormat('id').format(amount.item.amount) }}
                </template>
              </b-table>
            </b-card>
          </b-col>
        </b-row>
      </b-overlay>
    </section>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BCardText, BOverlay,
  BBadge, BDropdown, BDropdownItem, BPagination, BModal, BAlert, BInputGroup, BInputGroupPrepend, BForm, BFormGroup, VBTooltip,
} from 'bootstrap-vue'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import { codeHover } from '../components/collapse/code'
import stores from '../../functions/basics/stores'
import { listTransaction } from '../../functions/basics/transactions'
// import wordcloud from 'vue-wordcloud'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BModal,
    BAlert,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BCardText,
    AppCollapse,
    AppCollapseItem,
    flatPickr,
    vSelect,
    StatisticCardHorizontal,
    BOverlay,
    // wordcloud
  },
  data() {
    return {
      store: null,
      phone: null,
      uuid: null,
      utms: [],
      codeHover,
      rangeDate: null,
      stores: [],
      transactions: null,
      statuses: [],
      coupons: [],
      show: false,
      myColors: ['#1f77b4', '#629fc9', '#94bedb', '#c9e0ef'],
      defaultWords: [{
        name: 'Transporte Caro',
        value: 26,
      },
      {
        name: 'Sem dinheiro',
        value: 19,
      },
      {
        name: 'Desconto',
        value: 18,
      },
      {
        name: 'Insegurança',
        value: 16,
      },
      {
        name: 'Demorado',
        value: 15,
      },
      {
        name: 'Sem estoque',
        value: 9,
      },
      {
        name: 'Sem tamanho',
        value: 9,
      },
      ],
    }
  },
  async mounted() {
    this.stores = await stores()
  },
  methods: {
    async getStatus(transactions) {
      let paid = 0
      let canceled = 0
      let pending = 0
      let totalPaid = 0
      let totalCanceled = 0
      let totalPeding = 0

      this.coupons.length = 0

      transactions.map(element => {
        switch (element.status_id) {
          case 1:
            paid += 1
            totalPaid += parseFloat(element.amount)
            break
          case 2:
            canceled += 1
            totalCanceled += parseFloat(element.amount)
            break
          case 3:
            pending += 1
            totalPeding += parseFloat(element.amount)
            break
        }
      })
      console.log(new Intl.NumberFormat('id').format(totalPeding))
      return [{
        icon: 'DollarSignIcon',
        color: 'primary',
        amount: `${totalPaid}`,
        total: `${paid} Vendas`,
        customClass: '',
      },
      {
        icon: 'XCircleIcon',
        color: 'danger',
        amount: `${totalCanceled}`,
        total: `${canceled} cancelados`,
        customClass: '',
      },
      {
        icon: 'MoreHorizontalIcon',
        color: 'warning',
        amount: `${totalPeding}`,
        total: `${pending} Pendentes`,
        customClass: '',
      }]
    },
    async inArray(utm_compaigns, value) {
      let teste = false
      for (const utm_compaign in utm_compaigns) {
        if (utm_compaigns[utm_compaign].name === value) {
          teste = utm_compaign
        }
      }
      return teste
    },
    async getUTMS(uuid, range) {
      const dataRange = await range.replace(' ', '').split('to')
      const infos = await listTransaction(uuid, dataRange[0], dataRange[1])
      const teste = infos.utms

      teste.map(async element => {
        element.utm_campaigns = []

        for await (const transaction of infos.transactions) {
          const testinho = await this.inArray(element.utm_campaigns, transaction.utm_campaign)
          if (element.utm_source === transaction.utm_source && testinho === false && transaction.utm_source !== null && element.utm_source !== null && transaction.utm_campaign !== null) {
            element.utm_campaigns.push({ name: transaction.utm_campaign, total: 1, amount: parseFloat(transaction.amount) })
          } else if (testinho && element.utm_source === transaction.utm_source && transaction.utm_campaign !== null && element.utm_source !== null) {
            element.utm_campaigns[testinho].total += 1
            element.utm_campaigns[testinho].amount += parseFloat(transaction.amount)
          }
        }
      })

      this.statuses = await this.getStatus(infos.transactions)

      for await (const transaction of infos.transactions) {
        if (transaction.coupon !== null) {
          const coupon_in_array = await this.inArray(this.coupons, transaction.coupon)

          if (coupon_in_array === false) {
            this.coupons.push({ name: transaction.coupon, total: 1, amount: parseFloat(transaction.amount) })
          } else if (coupon_in_array) {
            this.coupons[coupon_in_array].total += 1
            this.coupons[coupon_in_array].amount += parseFloat(transaction.amount)
          }
        }
      }

      console.log(this.coupons)
      this.utms = teste
      console.log(teste)
      this.show = false
    },
  },
}
</script>
  <style lang="scss">
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
  </style>
